
// (function ($, Drupal) {
//   Drupal.behaviors.addClassToLeadershipLayout = {
//     attach: function (context, settings) {
//       let $title = $('.page-title span:contains("Leadership")').length;
//
//       if($title > 0) {
//         $('.layout__region.layout__region--first').css('flex', '1 0 15%');
//         $('.layout__region.layout__region--first').addClass('first-col');
//         $('.layout__region.layout__region--second').css('flex', '1 0 85%');
//         $('.layout__region.layout__region--second').addClass('second-col');
//       }
//     }
//   };
// })(jQuery, Drupal);

(function ($, Drupal, once) {
  Drupal.behaviors.addButtonClassToVideoAndRegistrationLinks = {
    attach: function (context, settings) {
      $(".field--name-field-event-video .field__item.event-item").addClass("btn bg-green");
      $(".field--name-field-registration .field__item.event-item").addClass("btn bg-green");
    }
  };

  // responsively hide the sidebar if there is no content for events pages
  // when using consortium-responsive-col layout
  Drupal.behaviors.hideSideBar = {
    attach: function (context, settings) {
      if ($(".layout-builder__section").length === 0) {
        let $sideBarContent = $("#responsive-sidebar").children('div');
        if ($sideBarContent.length > 0 && $sideBarContent.filter(function () {
          return $(this).text().trim().length || $(this).children().length;
        }).length === 0) {
          $("#responsive-sidebar").css("display", "none");
          $("#responsive-body").addClass("col-md-12");
        }
      }
    }
  };

  Drupal.behaviors.expandAll = {
    attach: function (context, settings) {
      // Ensure only one ID is set on the first matching element
      $(".all-member-centers .views-row:first-of-type .accordion-expand-all").attr("id", "accordion-link-first");

      // Trigger a click event on all expand all links when the first expand all link is clicked
      once('expandAll', context.querySelectorAll("#accordion-link-first")).forEach((element) => {
        element.addEventListener("click", function () {
          // Find all `.accordion-expand-all` except `#accordion-link-first`
          document.querySelectorAll(".accordion-expand-all:not(#accordion-link-first)").forEach((anchor) => {
            anchor.click();
          });
        });
      });
    }
  };

  Drupal.behaviors.formatTitle = {
    attach: function (context, settings) {
      once('format-title', '.pub-title a', context).forEach(function (element) {
        let $element = $(element); // Convert to jQuery object
        let text = $element.text().trim();
        //Check if string ends with punctuation
        if (!/[?!.]$/.test(text)) {
          $element.text(text + ".");
        }
      });
    }
  };



})(jQuery, Drupal, once);
